module.exports = __webpack_public_path__ + "static/media/other-link.a281e1e0.svg";